<script>
export default {
  name: 'Closedeyes',
  props: {
    status: {
      type: Boolean
    }
  },
  render: function(h, context) {
    const Closedeyes = (
      <i>
        <svg
          t='1573109663781'
          class='icon'
          viewBox='0 0 1024 1024'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          p-id='5153'
          width='1em'
          height='1em'
        >
          <path
            d='M941.677 391.71c9.338-14.006 6.225-32.681-6.225-43.575-14.006-10.894-32.681-7.781-43.575 6.225-1.557 1.556-174.3 205.426-379.728 205.426-199.2 0-379.727-205.426-381.283-206.982-10.895-12.45-31.125-14.006-43.576-3.113-12.45 10.894-14.006 31.125-3.113 43.576 3.113 4.668 40.463 46.687 99.6 93.375l-79.37 82.482c-12.45 12.45-10.893 32.681 1.557 43.575 3.113 6.225 10.894 9.338 18.676 9.338 7.78 0 15.562-3.113 21.787-9.338l85.594-88.706c40.463 28.013 88.707 54.47 141.62 73.144l-32.682 110.495c-4.668 17.118 4.67 34.237 21.788 38.906h9.337c14.006 0 26.457-9.338 29.569-23.344l32.681-110.495c24.9 4.669 51.357 7.782 77.813 7.782s52.913-3.113 77.814-7.782l32.68 108.939c3.114 14.006 17.12 23.343 29.57 23.343 3.113 0 6.225 0 7.782-1.556 17.118-4.67 26.456-21.787 21.788-38.906L649.099 595.58c52.914-18.676 101.157-45.132 141.62-73.144l84.038 87.15c6.225 6.225 14.006 9.338 21.787 9.338 7.781 0 15.563-3.113 21.787-9.337 12.45-12.451 12.45-31.125 1.557-43.576l-79.37-82.481c63.808-46.689 101.16-91.82 101.16-91.82z'
            p-id='5154'
          ></path>
        </svg>
      </i>
    );

    const Openeyes = (
      <svg
        t='1573110058379'
        class='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='5280'
        width='1em'
        height='1em'
      >
        <path
          d='M1003.657143 482.514286C895.314286 254.285714 731.542857 139.428571 512 139.428571c-219.657143 0-383.314286 114.857143-491.657143 343.2a68.914286 68.914286 0 0 0 0 58.857143C128.685714 769.714286 292.457143 884.571429 512 884.571429c219.657143 0 383.314286-114.857143 491.657143-343.2 8.8-18.514286 8.8-40 0-58.857143zM512 802.285714c-184.342857 0-319.314286-93.485714-414.514286-290.285714C192.685714 315.2 327.657143 221.714286 512 221.714286c184.342857 0 319.314286 93.485714 414.514286 290.285714C831.428571 708.8 696.457143 802.285714 512 802.285714z m-4.571429-491.428571c-111.085714 0-201.142857 90.057143-201.142857 201.142857s90.057143 201.142857 201.142857 201.142857 201.142857-90.057143 201.142858-201.142857-90.057143-201.142857-201.142858-201.142857z m0 329.142857c-70.742857 0-128-57.257143-128-128s57.257143-128 128-128 128 57.257143 128 128-57.257143 128-128 128z'
          p-id='5281'
        ></path>
      </svg>
    );
    if (this.status) {
      return Openeyes;
    } else {
      return Closedeyes;
    }
  }
};
</script>
